// extracted by mini-css-extract-plugin
export var dropdownContainer = "_40-5";
export var imageContainer = "_40-4";
export var metricsGrid = "_40-2";
export var productDetailContainer = "_40-1";
export var productListContainer = "_40-0";
export var subscriberTableContainer = "_40-3";